import * as React from "react";

import { MAX_CHANGE_NUM } from "../../../../constants/schoolOrderChangeRequest";

import style from "./GradeEditDialog.module.scss";

export interface GradeEditDialogProps {
  label: string;
  canEditDlp: boolean;
  canEditG4s: boolean;
  currentDlp: number;
  currentG4s: number;
  usedDlp: number;
  usedG4s: number;
  initialDlp: number;
  initialG4s: number;
  onSave: (dlp: number, g4s: number) => void;
  closeModal: () => void;
}

const validateValue = (value: string, current: number, used: number) => {
  if (!/^\d+$/.test(value)) {
    return "0以上の整数で入力してください";
  }
  if (Math.abs(Number(value) - current) > MAX_CHANGE_NUM) {
    return `現在の人数から増減${MAX_CHANGE_NUM}人以内で入力してください`;
  }
  if (Number(value) < used) {
    return `利用中の生徒が${used}人いるため${used}人未満に変更できません`;
  }
  return "";
};

export const GradeEditDialog = (props: GradeEditDialogProps) => {
  const [state, setState] = React.useState({
    dlp: String(props.initialDlp),
    g4s: String(props.initialG4s),
  });

  const dlpError = props.canEditDlp
    ? validateValue(state.dlp, props.currentDlp, props.usedDlp)
    : "";
  const g4sError = props.canEditG4s
    ? validateValue(state.g4s, props.currentG4s, props.usedG4s)
    : "";
  const errorMessage = dlpError
    ? `教材利用可能人数：${dlpError}`
    : g4sError
    ? `GEAR利用可能人数：${g4sError}`
    : "";

  const onSave = () => {
    props.onSave(
      props.canEditDlp ? Number(state.dlp) : props.currentDlp,
      props.canEditG4s ? Number(state.g4s) : props.currentG4s,
    );
    props.closeModal();
  };

  return (
    <main className={style.main}>
      <div className={style.header}>
        <div className={style.title}>{props.label}の人数変更</div>
        {props.canEditDlp && (
          <div className="mb-3">
            <label className="form-label" htmlFor="dlp_registrable_num">
              教材利用可能人数（現在：{props.currentDlp}人 / 利用中：
              {props.usedDlp}人）
            </label>
            <div className="input-group">
              <input
                type="number"
                min={0}
                className={"form-control"}
                id="dlp_registrable_num"
                value={state.dlp}
                onChange={e => setState({ ...state, dlp: e.target.value })}
              />
            </div>
          </div>
        )}
        {props.canEditG4s && (
          <div className="mb-3">
            <label className="form-label" htmlFor="g4s_registrable_num">
              GEAR利用可能人数（現在：{props.currentG4s}人 / 利用中：
              {props.usedG4s}人）
            </label>
            <div className="input-group">
              <input
                type="number"
                min={0}
                className={"form-control"}
                id="g4s_registrable_num"
                value={state.g4s}
                onChange={e => setState({ ...state, g4s: e.target.value })}
              />
            </div>
          </div>
        )}
        {errorMessage && <div className={style.caution}>{errorMessage}</div>}
      </div>
      <div className={style.body}>
        <div className={style.btnArea}>
          <button
            className="btn btn-secondary"
            onClick={() => props.closeModal()}
          >
            {"キャンセル"}
          </button>
          <button
            className={"btn " + style.okBtn}
            disabled={!!errorMessage}
            onClick={onSave}
          >
            {"OK"}
          </button>
        </div>
      </div>
    </main>
  );
};

export default GradeEditDialog;
